import store from '../store';
import Constants from '../config/constants';
import {serviceGetIncentiveReportRupeeValue} from "../services/IncentiveReport.service";

export const FETCH_INIT = 'FETCH_INIT_RUPEE_VALUE';
export const FETCHED = 'FETCHED_RUPEE_VALUE';
export const FETCHED_FAIL = 'FETCHED_FAIL_RUPEE_VALUE';
export const FETCHED_FILTER = 'FETCHED_FILTER_RUPEE_VALUE';
export const FETCH_NEXT = 'FETCH_NEXT_RUPEE_VALUE';
export const FILTER = 'FILTER_RUPEE_VALUE'; 
export const RESET_FILTER = 'RESET_FILTER_RUPEE_VALUE';
export const SET_SORTING = 'SET_SORTING_RUPEE_VALUE';
export const SET_FILTER = 'SET_FILTER_RUPEE_VALUE';
export const SET_PAGE = 'SET_PAGE_RUPEE_VALUE';
export const CHANGE_PAGE = 'CHANGE_PAGE_RUPEE_VALUE';
export const CHANGE_STATUS= 'CHANGE_STATE_RUPEE_VALUE';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_RUPEE_VALUE';
export const CREATE_DATA = 'CREATE_RUPEE_VALUE';
export const UPDATE_DATA = 'UPDATE_RUPEE_VALUE';
export const DELETE_ITEM = 'DELETE_RUPEE_VALUE';


export function actionFetchIncentiveReportRupeeValue(index = 1, sorting = {}, filter = {}) {
    const request = serviceGetIncentiveReportRupeeValue({ index, row: sorting.row, order: sorting.order, ...filter });
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: SET_FILTER, payload: filter});
            dispatch({type: SET_SORTING, payload: sorting});
            if (!data.error) {
                dispatch({type: FETCHED, payload: { data: data.data, page: index }});
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index == 1) {
                    dispatch({type: CHANGE_PAGE, payload: index - 1});
                }
            } else {
                dispatch({type: FETCHED_FAIL, payload: null});
            }
        });
    };
}

export function actionChangePageIncentiveReportRupeeValue(page) {
    return (dispatch) => {
        dispatch({type: CHANGE_PAGE, payload: page})
    }
}


export function actionFilterIncentiveReportRupeeValue(value) {
    const request = null;
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: FILTER, payload: data});
            dispatch({type: FETCHED, payload: null});
        });
    };
}


export function actionChangeStatusIncentiveReportRupeeValue(id, status) {
    return (dispatch) => {
        dispatch({type: CHANGE_STATUS, payload: {id, status}});
    };
}

export function actionResetFilterIncentiveReportRupeeValue() {
    return {
        type: RESET_FILTER,
        payload: null,
    };
}

export function actionSetPageIncentiveReportRupeeValue(page, extraPayload = {}) {
    const stateData = store.getState().rupee_value;
    const currentPage = stateData.currentPage;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const query = stateData.query;
    const queryData = stateData.query_data; 
    const serverPage = stateData.serverPage;

    if (totalLength <= ((page + 1) * Constants.DEFAULT_PAGE_VALUE)) {
        store.dispatch(actionFetchIncentiveReportRupeeValue(serverPage + 1, sortingData, {query, query_data: queryData,   ...extraPayload}));
    }

    console.log(currentPage, totalLength);
    return {
        type: CHANGE_PAGE,
        payload: page,
    };

}
